import React, { useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import classNames from 'classnames';
import { SETTINGS_NAVIGATION_IDS, SETTINGS_ITEMS } from 'constants/navigation';
import { UserCircleIcon, BellIcon } from '@heroicons/react/24/outline';

const NAVIGATION_ICONS = {
  [SETTINGS_NAVIGATION_IDS.GENERAL]: UserCircleIcon,
  [SETTINGS_NAVIGATION_IDS.NOTIFICATIONS]: BellIcon,
};

export default function SettingsSidebar() {
  const location = useLocation();

  const navigation = useMemo(() => {
    return SETTINGS_ITEMS.map((item) => ({
      ...item,
      icon: NAVIGATION_ICONS[item.id],
      isActive: location.pathname.includes(item.path),
    }));
  }, [location.pathname]);

  return (
    <aside className="flex overflow-x-auto border-b border-white/5 py-4 lg:block lg:w-64 lg:flex-none lg:border-0 lg:py-0">
      <nav className="flex-none px-4 sm:px-6 lg:px-0">
        <ul role="list" className="flex gap-x-3 gap-y-1 whitespace-nowrap lg:flex-col">
          {navigation.map((item) => (
            <li key={item.id}>
              <Link
                to={item.path}
                className={classNames(
                  item.isActive
                    ? 'bg-gray-800 text-indigo-400'
                    : 'text-gray-400 hover:bg-gray-800 hover:text-white',
                  'group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold'
                )}
              >
                <item.icon
                  className={classNames(
                    item.isActive ? 'text-indigo-400' : 'text-gray-400 group-hover:text-white',
                    'h-6 w-6 shrink-0'
                  )}
                  aria-hidden="true"
                />
                {item.title}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </aside>
  );
}
